'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isPlainObject = require('is-plain-object');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _predicates = require('../internal/predicates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (thing) {
  return (0, _predicates.isCollection)(thing) || (0, _predicates.isValueObject)(thing) || Array.isArray(thing) || (0, _isPlainObject2.default)(thing);
};


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/util/isValueObject.js
// module id = 274
// module chunks = 35783957827783